import { Link } from "react-router-dom";

// [NEW] Who can do what with KRAs/KPIs, by role. Mirrors the backend rules (migration 013):
// managers work on their own team, HR/Admin on the whole organization.
// "where" links to the screen in the app for each role.
export const ACCESS_MATRIX = [
  // [UPDATED] PM-15/16/17: employees add their own KRAs, KPIs and goals; managers approve, edit or return them;
  // HR reviews and corrects but does not assign.
  {
    fn: "Add KRA/KPI and goals",
    employee: { text: "Yes, own", where: "/my-kra-kpi" },
    manager: { text: "No" },
    hr: { text: "No" },
  },
  {
    fn: "Approve KRA/KPI and goals",
    employee: { text: "No" },
    manager: { text: "Direct reports", where: "/team/kra-kpi-proposals" },
    hr: { text: "No" },
  },
  {
    fn: "Edit KRA/KPI and goals",
    employee: { text: "Own, before approval", where: "/my-kra-kpi" },
    manager: { text: "Direct reports, while approving", where: "/team/kra-kpi-proposals" },
    hr: { text: "All employees, with a reason", where: "/hr/kra-kpi" },
  },
  {
    fn: "Assign KRA/KPI or goals",
    employee: { text: "No" },
    manager: { text: "No" },
    hr: { text: "No" },
  },
  {
    fn: "KRA/KPI library and role templates",
    employee: { text: "No" },
    manager: { text: "No" },
    hr: { text: "No" },
  },
  {
    fn: "View audit/history",
    employee: { text: "Own activity only", where: "/my-activity" },
    manager: { text: "Own activity only", where: "/my-activity" },
    hr: { text: "Own activity only", where: "/my-activity" },
  },
  {
    fn: "Submit progress against KRA/KPI",
    employee: { text: "Own items", where: "/my-kra-kpi" },
    manager: { text: "Approve team updates", where: "/team/progress-approvals" },
    hr: { text: "Organisation-wide oversight", where: "/reports" },
  },
];

const COLUMNS = [
  { key: "employee", label: "Employee", views: ["employee"] },
  { key: "manager", label: "Manager", views: ["manager"] },
  { key: "hr", label: "HR/Admin", views: ["hr", "admin"] },
];

function Cell({ value, linkable }) {
  const off = value.text === "No" || value.text === "No direct assignment";
  return (
    <td className={`${off ? "is-off" : ""} ${linkable ? "is-you" : ""}`}>
      {linkable && value.where ? <Link to={value.where}>{value.text}</Link> : value.text}
    </td>
  );
}

export default function AccessMatrix({ activeView = "" }) {
  return (
    <div className="table-wrap">
      <table className="data-table access-matrix">
        <thead>
          <tr>
            <th scope="col">Function</th>
            {COLUMNS.map((c) => (
              <th key={c.key} scope="col" className={c.views.includes(activeView) ? "is-you" : ""}>
                {c.label}{c.views.includes(activeView) && <span className="you-chip">you</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ACCESS_MATRIX.map((row) => (
            <tr key={row.fn}>
              <th scope="row">{row.fn}</th>
              {COLUMNS.map((c) => <Cell key={c.key} value={row[c.key]} linkable={c.views.includes(activeView)} />)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
